import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom'; // Use useNavigate here
import { toast } from 'react-toastify';
import AccountAggregatorStatementLayout from '../components/AccountAggreagtorStatement/AccountAggregatorStatementLayout';
import LoadingSpinner from '../components/LoadingSpinner';
import BankStatements from '../components/AccountAggreagtorStatement/BankStatements';
import axiosInstance from '../utils/axiosInstance';


const BankStatementPage = () => {
    const {id}=useParams()
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const location = useLocation();
  const navigate = useNavigate(); // Use useNavigate hook for navigation
  const queryParams = new URLSearchParams(location.search);
  const bank = queryParams.get('bank'); // Get the bank query parameter

  const fetchRequestData = async () => {
    if (!id || Array.isArray(id)) {
      toast.error('Invalid ID');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await axiosInstance.get(`/account-aggregator/get-fi-request/${id}`);
      setData(response.data.data);
      setLoading(false);
    } catch (error) {
      setError(error?.response?.data?.message || 'Failed to fetch bank statements');
      toast.error(error?.response?.data?.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchRequestData();
    }
  }, [id]);

  // Map documents to banks
  const banks = data?.banks.map((doc) => ({
    id: doc.bankInformationId,
    name: doc.bankName,
  }));

  // Get the selected bank index from the query
  const selectedBankIndex = bank ? parseInt(bank, 10) : 0; // Default to 0 if not specified

  return (
    <div>
      {data?.userId&&<AccountAggregatorStatementLayout banks={banks} userId={data.userId} />}
      {!data && <LoadingSpinner />}
      {data && (
        <BankStatements
          data={data.banks}
          
          documentIndex={selectedBankIndex} // Pass the selected index
        />
      )}
    </div>
  );
};

export default BankStatementPage;
